import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import "./VideoNotes.scss";
import {
    Button, Dropdown,
    Form,
    Input,
    InputRef, message,
    Modal,
    Popconfirm, Popover, Spin, Switch,
    TimePicker,
} from "antd";
import { getEmbedLink } from "../../element/embeddable";
import { toValidURL } from "../../data/url";
import YouTube, { YouTubePlayer, YouTubeProps } from "react-youtube";
import dayjs from "dayjs";
import { VideoNotesType } from "../../types";
import { videoCache } from "../App";
import { mutateElement } from "../..";
import i18n, {t} from "i18next";
import {
    createCopyLink,
    formatDate,
    generateUUID2, getFileName, getImagePath, getImagePathSvg,
    getImagePathWithTheme,
    getItem,
    getLocalFilePath,
    getQueryParam,
    getUrlQueryParam,
    getVideoSnapShotByVideo,
    getYoutubeThumbImage,
    getYoutubeThumbUrl,
    hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix,
    isAudio,
    isBaiduVideoUrl,
    isBilibiliUrl,
    isDarkMode, isObject,
    isString,
    isSupportVideoAnnoUrl,
    isVideo,
    isYoutubeUrl, parseVideoTranscript, sleep
} from "../../../../../src/utils";
import {dbGetHighlight, getCardById, updateCard, updateHighlight} from "../../../../../model";
import html2canvas from "html2canvas";
import {postMessage} from "../../../../../src/common/event";
import {
    EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_REFRESH_DEEPLINK,
    EVENT_REFRESH_HIGHLIGHT_LIST, EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_VIDEO_ANNO_ELEMENT, EVENT_REFRESH_VIDEO_NOTE, EVENT_REFRESH_VIDEO_TITLE,
    EVENT_TEST_ONDRAG_NOTE, FROM_DIALOG, FROM_HOME_DIALOG,
    FROM_LIBRARY, HAS_VIDEO_CAPTURE_TEST, MAX_Z_INDEX, MEDIIUM_Z_INDEX
} from "../../../../../src/Const";
import {
    IconClose, IconClose20,
    IconCopyLink,
    IconDelete,
    IconEdit,
    IconIndicatorBlue,
    IconInfoMenu,
    IconManagerTags
} from "../../../../../src/Icon";
import {beyondFreeYoutubeHightlightLimit, isMac} from "../../../../../src/Utility";
import {isZh} from "../../../../../src/language";
import {ipcInvoke, ipcSend} from "../../../../../src/common/ipc";
import global from "../../../../../src/global";
import VideoOtherContent from "./VideoOtherContent";
import {apiBilibiliCover} from "../../../../../src/api/ThirdApi";
import {saveElementVideoNotesAsJSON} from "../../data/json";
import {APP_WEB, isWeb} from "../../../../../src/electron_interactive";
import {copyImageToClipboard, getBaiduVideoNameByUrl} from "../../../../../src/Utility0";
import chardet from 'chardet'
import TabHighlightTranscript from "./TabHighlightTranscript";
import {useAtom} from "jotai";
import {atomTranscriptDialogHasBanner} from "../../../../../src/views/Home/HomeIndex";

export interface VideoContentProps {
  videoNotes: VideoNotesType;
  from?:any;
  pointerEvents?:any;
  subFrom?:any;
  hasHeader?:any;
    dialogSize?:any;
    isFullScreen?:any;
}
const getCurrentHoursMinutesSeconds = (seconds: number) => {
  const currentHours = Math.floor(seconds / 3600);
  const currentMinutes = Math.floor((seconds % 3600) / 60);
  const currentSeconds = Math.floor(seconds % 60);
  return {
    currentHours,
    currentMinutes,
    currentSeconds,
  };
};

const getRemainingHoursMinutesSeconds = (seconds: number) => {
  const { currentHours, currentMinutes, currentSeconds } =
    getCurrentHoursMinutesSeconds(seconds);

  const remainingHoursRange = Array.from(
    { length: 24 - currentHours - 1 },
    (_, i) => i + currentHours + 1,
  );
  const remainingMinutesRange = Array.from(
    { length: 60 - currentMinutes - 1 },
    (_, i) => i + currentMinutes + 1,
  );
  const remainingSecondsRange = Array.from(
    { length: 60 - currentSeconds - 1 },
    (_, i) => i + currentSeconds + 1,
  );

  return {
    remainingHoursRange,
    remainingMinutesRange,
    remainingSecondsRange,
  };
};
const timeString2HoursMinutesSeconds = (timeString: string) => {
  const parts = timeString.split(":");

  // 提取小时、分钟和秒，并将它们转换为数字
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(parts[2], 10);
  return {
    hours,
    minutes,
    seconds,
  };
};
const getSpecificTimeOfDay = (
  hours: number,
  minutes: number,
  seconds: number,
) => {
  // 获取当前日期
  const currentDate = dayjs();
  // 设置指定时间
  const specificTime = currentDate.hour(hours).minute(minutes).second(seconds);
  return specificTime;
};
const getSeconds = (timestamp: number) => {
  const dayjsObject = dayjs(timestamp);
  const hours = dayjsObject.hour();
  const minutes = dayjsObject.minute();
  const seconds = dayjsObject.second();
  return hours * 3600 + minutes * 60 + seconds;
};
const getTimeText = (timestamp: number) => {
  // 使用时间戳创建dayjs对象
  const dayjsObject = dayjs(timestamp);

  const hours = dayjsObject.hour().toString().padStart(2, "0");
  const minutes = dayjsObject.minute().toString().padStart(2, "0");
  const seconds = dayjsObject.second().toString().padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};
const groupByTimestamp = (data: string[]): string[][] => {
  const groups: string[][] = [];
  let currentGroup: string[] = [];

  data.forEach((item) => {
    if (item.startsWith("[timestamp]:")) {
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [item];
    } else {
      currentGroup.push(item);
    }
  });

  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
};

let mSelectItem:any;

const VideoContent = memo(
  forwardRef(({ videoNotes,from,pointerEvents,subFrom,hasHeader,dialogSize,isFullScreen }: VideoContentProps, ref) => {
      const inputFileRef = useRef<HTMLInputElement>(null);
      const youtubeRef: YouTubePlayer = useRef(null);
      const youtubeElementRef = useRef(null);
      const disabledTime = useRef<any>(null);
      const inputRef = useRef<InputRef>(null);
      const videoNoteWrapperRef = useRef<HTMLDivElement>(null);
      const videoOtherContainerRef = useRef(null);

      const [form] = Form.useForm();
      const {element, src, type, visibility} = useMemo(() => {
          const src = getEmbedLink(toValidURL(videoNotes.element.link || ""));
          return {...videoNotes, src};
      }, [videoNotes]);

      const [isReady, setIsReady] = useState(false);
      const [drawerVisible, setDrawerVisible] = useState(false);
      const [elementVideoNotes, setElementVideoNotes] = useState<VideoNoteType[]>(
          [],
      );
      const [activeNote, setActiveNote] = useState<VideoNoteType | null>(null);
      const [editedNote, setEditedNote] = useState<VideoNoteType | null>(null);
      const [isLoading, setIsLoading] = useState(true);
      const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);

      // const [isFullScreen,setIsFullScreen] = useAtom(atomIsFullScreen);
      const [isMouseEnterCapture, setIsMouseEnterCapture] = useState(false);
      const [endTime, setEndTime] = useState<any>(0);
      const [isPopoverEndTimeOpen, setIsPopoverEndTimeOpen] = useState(false);
      const [hasLoop, setHasLoop] = useState(false);
      const [capturePath, setCapturePath] = useState('');

      const mszCapturePath = useRef<any>(null);
      let mszSearchKeyRef = useRef('');
      const libraryDataRef = useRef(null);
      const iframeYoutubeRef = useRef<any>(null);
      const intervalRef = useRef<any>(null);
      const mActiveNoteRef = useRef(null);
      const mAutoPlay = useRef(false);
      const mYoutubeTitle = useRef(null);
      const tabHighlightTranscriptRef = useRef(null);
      const tabHighlightTranscriptFromDialogRef = useRef(null);
      const [isExpand,setIsExpand] = useState(false);
      const [hasTranscript,setHasTranscript] = useState(false);
      const mElementVideoNotesRef = useRef<any>([]);
      const[hasTranscriptBanner,setHasTranscriptBanner] = useAtom(atomTranscriptDialogHasBanner);

      const MORE_MENU = [
          getItem(i18n.t("Edit"), 'edit', <IconEdit/>, undefined, undefined, () => {
              editNote(mSelectItem)
          }),
          getItem(i18n.t("Copy link"), 'copyLink',  <IconCopyLink/>, undefined, undefined, () => {
              createCopyLink("highlight", element.customData?.generationData?.id || element.id, 'videoNote', mSelectItem?.id);
          }),
          getItem(i18n.t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, () => {
              getCardById(mSelectItem?.id)?.then(res => {
                  window.showInfo('library',res);
              })
          }),
          getItem(i18n.t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, () => {
              getCardById(mSelectItem?.id)?.then(res => {
                  window.showManageTags([res]);
              })
          }),
          getItem(i18n.t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
              window.showMessageBox(t("Tips"), t("SureDeleteHighlight"), t("Cancel"), t("Delete"), null, () => {
                  deleteNote(mSelectItem);
              })
          }),
      ]

      const getHeight = () => {
          // if (from == 'slider'){
          //     if (isMac()){
          //         if (hasHeader){
          //             return 'calc(60vh - 130px)'
          //         }
          //         return 'calc(60vh - 80px)';
          //     }
          //     return 'calc(60vh - 110px)'
          // }else if (from == FROM_LIBRARY){
          //     if (isMac()){
          //         return 'calc(60vh - 130px)'
          //     }else{
          //         return 'calc(60vh - 160px)'
          //     }
          // }
          // return 'calc(60vh - 80px)';
          return '100%';
      }


      const rightStyle = from == 'slider' ? {
          display: 'flex',
          flexDirection: 'column',
          height: getHeight(),
          position: 'relative',
          overflow: 'hidden auto'
      } : {}

      /**
       * 关闭小屏幕的偏移
       */
      const getTopOffset = () => {
          if (document.body.clientHeight < 1000) {
              return document.body.clientHeight / 1000.0 * 300;
          }
          return 320;
      }

      const modalStyle = (from == 'slider') ? {
          top: `calc(50vh - ${getTopOffset()}px)`,
          left: 'calc(50vw - 240px)'
      } : {top: '10px', left: '21.2vw'}

      // const modalStyle = () => {
      //     if (from == 'slider') {
      //         if (isAudio(element.customData?.generationData.fileName) && subFrom != FROM_LIBRARY) {
      //             return {top: '30px'};
      //         }
      //         if (document.body.clientHeight <= 940){
      //             return {top: 'calc(50vh - 220px)', left: 'calc(50vw - 240px)'};
      //         }
      //         return {top: 'calc(50vh - 300px)', left: 'calc(50vw - 240px)'};
      //     } else if (from == FROM_DIALOG) {
      //         return {top: '10px', left: '21.2vw'};
      //     }
      //     return (from == 'slider') ? {top: 'calc(50vh - 320px)', left: 'calc(50vw - 240px)'} : {
      //         top: '10px',
      //         left: '21.2vw'
      //     }
      // }

      const onChangeTimePicker = (time: any) => {
          const hours = time.hour();
          const minutes = time.minute();
          const seconds = time.second();

          seekTo(hours, minutes, seconds);
      };

      //保存笔记
      const confirmNote = async (isQuickNote = false,time:any = null) => {
          if (APP_WEB) {
              setDrawerVisible(false);
              return;//web不保存.
          }

          const fieldValues = form.getFieldsValue(true);
          let szCapturePath = mszCapturePath.current;
          if (!fieldValues.title && !fieldValues.content) {
              fieldValues.content = i18n.t('Quick note');
              if (isQuickNote){
                  // szCapturePath = '';
                  // setCapturePath('')
              }
          }

          let timestamp = fieldValues.time?.valueOf();
          if (fieldValues.time == null  && time == null){
              let currentTime = await getCurrentTime();

              const {currentHours, currentMinutes, currentSeconds} =
                  getCurrentHoursMinutesSeconds(currentTime);
              const timePickerValue = getSpecificTimeOfDay(
                  Math.floor(currentHours),
                  Math.floor(currentMinutes),
                  Math.floor(currentSeconds),
              );

              timestamp = timePickerValue.toDate().getTime();//S 不用秒保存，非得用个时间...
          }

          if (time != null){
              const dtNow = new Date();
              dtNow.setHours(0);
              dtNow.setMinutes(0);
              dtNow.setSeconds(time);
              timestamp = dtNow;
          }

          const editedNoteId = editedNote?.id;
          const currentNotes = await getCurrentNotes();

          let szCurrentId = editedNoteId;
          if (!szCurrentId) {
              szCurrentId = Date.now() + '';
          }

          let nEndTime = 0;
          if (endTime) {
              nEndTime = endTime.toDate().getTime();
          }

          let newElementVideoNotes = editedNoteId
              ? currentNotes.map((item) => {
                  return item.id === editedNoteId
                      ? {
                          ...item,
                          ...fieldValues,
                          time: timestamp,
                          updateTime: Date.now(),
                          endTime: nEndTime,
                          loop: hasLoop,
                          thumbImage: szCapturePath
                      }
                      : item;
              })
              : [
                  {
                      ...fieldValues,
                      id: szCurrentId,
                      time: timestamp,
                      createTime: Date.now(),
                      updateTime: Date.now(),
                      endTime: nEndTime,
                      loop: hasLoop,
                      thumbImage: szCapturePath
                  },
                  ...currentNotes,
              ];
          newElementVideoNotes = newElementVideoNotes.sort(
              (a, b) => getSeconds(a.time) - getSeconds(b.time),
          );

          //选择的note
          if (mActiveNoteRef.current){
              const note00000 = newElementVideoNotes.find(p=>p.id == mActiveNoteRef.current?.id);
              if (note00000){
                  mActiveNoteRef.current = note00000;
              }
          }

          mutateElement(element, {videoNotes: newElementVideoNotes}, false);
          setElementVideoNotes(newElementVideoNotes);

          if (onAction) {
              const data = newElementVideoNotes.find(p => p.id == szCurrentId);
              if (youtubeRef.current) {
                  onAction('updateNote', {
                      ...data,
                      src: src,
                      name: youtubeRef.current?.videoTitle || '',
                      libraryId: element.customData?.generationData?.id || element.id
                  });
              } else if (videoOtherContainerRef.current) {
                  let videoInfo = null;
                  let szName = '';
                  if (isBilibiliUrl(element.link)){
                      let videoInfo = videoOtherContainerRef.current?.onGetVideoInfo();
                      szName = videoInfo?.title || "";
                  }else if (isYoutubeUrl(element.link)){
                      szName = mYoutubeTitle.current || ''
                  }else if (isBaiduVideoUrl(element.link)){
                      szName = getBaiduVideoNameByUrl(element.link)
                  }

                  onAction('updateNote', {...data, src: element.link, name: szName, libraryId:element.customData?.generationData?.id || element.id});
              }
          }

          if (editedNoteId){
              //修改注记文件..
              postMessage(EVENT_REFRESH_VIDEO_ANNO_ELEMENT, {...fieldValues, id: editedNoteId,thumbImage:szCapturePath,loop:hasLoop,endTime:endTime});
          }

          videoCache.set(element.customData?.generationData?.id || element.id, newElementVideoNotes);
          //保存到数据库
          updateToDb(newElementVideoNotes);

          if (mszSearchKeyRef.current) {
              setTimeout(() => {
                  onSearch(mszSearchKeyRef.current);
              }, 50);
          }

          if (!editedNoteId) {
              const item = {
                  ...fieldValues,
                  id: Date.now(),
                  time: timestamp,
              };
              setActiveNote(item);

              setTimeout(() => {
                  // const children = Array.from(
                  //     videoNoteWrapperRef.current?.children || [],
                  // );
                  // const activeChild = children.find((child) => {
                  //     return child.classList.contains("one-note-acitve");
                  // });
                  // if (activeChild) {
                  //     activeChild.scrollIntoView({behavior: "smooth"});
                  // }
                  autoScrollToSelected(item);
              }, 250);
          }
          setDrawerVisible(false);


      };

      /**
       * 保存到数据库
       * @param newElementVideoNotes
       */
      const updateToDb = async (newElementVideoNotes: any) => {
          let szName = "";
          let szThumbImage = '';
          if (youtubeRef.current || isYoutubeUrl(element.link)) {
              szName = youtubeRef.current?.videoTitle || '';
              szThumbImage = getYoutubeThumbUrl(src?.videoId);
          } else if (videoOtherContainerRef.current) {
              const videoInfo = videoOtherContainerRef.current?.onGetVideoInfo();
              szName = videoInfo?.title || "";
          }

          const dbHigh = await dbGetHighlight(element.customData?.generationData?.id || element.id);
          if (dbHigh) {
              if (dbHigh.thumbImage){
                  szThumbImage = dbHigh.thumbImage;
              }

              if (dbHigh.name) {
                  szName = dbHigh.name;
              }
          }

          //这里要从库里面取一个名字--路径、画布--右侧栏--重命名   然后又点了标注。。。这时候更新name 就有问题了。。
          const library = await getCardById(element.customData?.generationData?.id || element.id);
          if (library){
              if (element.customData?.generationData){
                  element.customData.generationData.name = library.name;
              }
          }

          if (!szThumbImage) {
              if (isBilibiliUrl(videoNotes.element.link)) {
                  apiBilibiliCover(videoNotes.element.link).then(res => {
                      //如果获取到缩略图，这里再更新一下...
                      updateHighlight({
                          id: element.customData?.generationData?.id || element.id,
                          url: element.link,
                          name: szName || res.title || '',
                          data: newElementVideoNotes,
                          type: 'youtube',
                          thumbImage: res.pic
                      })
                  })
              }
          }

          updateHighlight({
              id: element.customData?.generationData?.id || element.id,
              url: element.link,
              name: szName || '',
              data: newElementVideoNotes,
              type: 'youtube',
              thumbImage: szThumbImage
          }).then(res => {
              postMessage(EVENT_REFRESH_HIGHLIGHT_LIST);
              postMessage(EVENT_REFRESH_DEEPLINK, {id: videoNotes.element?.customData?.generationData?.id || element.id})

              //刷新注记
              if (window.onRefreshAnnoCount){
                  window.onRefreshAnnoCount();
              }
          });
      }

      /**
       * 操作
       * @param szAction
       * @param data
       */
      const onAction = async (szAction: any, data: any) => {
          if (!data.name) {
              const library = await getCardById(data.libraryId);
              if (library) {
                  data.name = library?.name;
              }
          }

          if (szAction == 'updateNote') {
              const videoAnno = {
                  ...data,
                  type: 'videoAnno',
              }
              //标签
              const item = await getCardById(data.id);
              if (item) {
                  videoAnno.tags = item.tags;
              }
              await updateCard(videoAnno);
          } else if (szAction == 'deleteNote') {
              const videoAnno = {
                  ...data,
                  type: 'videoAnno',
                  deleteTime: Date.now(),
                  isDeleted: 1
              }
              await updateCard(videoAnno);
              postMessage(EVENT_DELETE_ELEMENT_BY_ID,{id:data.id});
          }
          postMessage(EVENT_REFRESH_VIDEO_NOTE, {id: data.id})
          postMessage(EVENT_REFRESH_LIBRARY_LIST);

      }

      /**
       * 自动滚动到
       */
      const autoScrollToSelected = (note: any) => {
          const div = document.getElementById('div-video-note-item-' + note.id);
          const divContainer = document.getElementById('div-url-video-note-container');
          if (div && divContainer) {
              // div.scrollIntoView({behavior:'smooth'})
              divContainer.scrollTo({
                  top: div.offsetTop - divContainer.clientHeight * 0.5,
                  behavior: 'smooth'
              })
          }
          if (mAutoPlay.current){
              videoOtherContainerRef.current?.onPlay();
          }
      }

      /**
       * 转到时间
       */
      const seekTo = (hours, minutes, seconds,hasReload) => {
          if (youtubeRef.current && (APP_WEB && isYoutubeUrl(element.link))) {
              try{
                  youtubeRef.current?.seekTo(hours * 3600 + minutes * 60 + seconds);
              }catch (e){

              }
          } else if (videoOtherContainerRef.current) {
              videoOtherContainerRef.current?.reloadIframe(hours * 3600 + minutes * 60 + seconds,hasReload)
          }
      }

      /**
       * 设置是否有结束时间或者loop
       * @param note
       */
      const setTimeUpdateCallbackLoop = (note)=>{
          if (note?.endTime){
              let nStartTimeSeconds = getSeconds(note.time);
              let nEndTimeSeconds = getSeconds(note.endTime);
              if (note.endTime){
                  if (videoOtherContainerRef.current){
                      videoOtherContainerRef.current?.onSetTimeUpdateCallback(nStartTimeSeconds,nEndTimeSeconds,note.loop)
                  }else if (youtubeRef.current){

                  }
              }
          }
      }

      const clickOneNote = (note: VideoNoteType,hasReload) => {
          const {time: timestamp} = note;
          const dayjsObject = dayjs(timestamp);
          const hours = dayjsObject.hour();
          const minutes = dayjsObject.minute();
          const seconds = dayjsObject.second();
          seekTo(hours, minutes, seconds,hasReload);

          // setTimeUpdateCallbackLoop(note);

          setActiveNote(note);
      };

      /**
       * 重置到点击条目的开始时间段
       * @param note
       */
      const onResetVideoToAnnoTime = (note) => {
          const {time: timestamp} = note;
          const dayjsObject = dayjs(timestamp);
          const hours = dayjsObject.hour();
          const minutes = dayjsObject.minute();
          const seconds = dayjsObject.second();
          seekTo(hours, minutes, seconds);
      }

      const getDuration = async () => {
          if (youtubeRef.current) {
              return youtubeRef.current.getDuration();
          } else if (videoOtherContainerRef.current) {
              return await videoOtherContainerRef.current.onGetVideoTime();
          }
          return 0;
      }

      const getCurrentTime = async ()=>{
          if (youtubeRef.current) {
              return youtubeRef.current.getCurrentTime();
          } else if (videoOtherContainerRef.current) {
              return await videoOtherContainerRef.current.onGetCurrentTime();
          }
          return 0;
      }

      /**
       * 暂停视频
       */
      const pauseVideo = () => {
          if (youtubeRef.current) {
              youtubeRef.current?.pauseVideo();
          } else if (videoOtherContainerRef.current) {
              videoOtherContainerRef.current?.onPauseVideo();
          }
      }

      const getCurrentNotes = async () => {
          //可能是change source 过的，id 不一样。各不相同...
          const highlight = await dbGetHighlight(element.customData?.generationData?.id || element.id);
          if (highlight) {
              return highlight.data;
          }
          return [];
      }

      const addNote = async () => {
          if (!hasLicense() && !hasDesktopBaseLicense() && elementVideoNotes.length == 0) {
              let isBeyond = await beyondFreeYoutubeHightlightLimit();
              if (isBeyond) {
                  window.showMessageBox(i18n.t("Upgrade required"), i18n.t("NeedUpgradeToAddVideoHightlight"), i18n.t("Cancel"), i18n.t("Learn more"), () => {
                      window.closeDialogFileImportLoading();
                  }, () => {
                      window.closeDialogFileImportLoading();
                      if (isZh()) {
                          ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                      } else {
                          ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                      }
                  })
                  return;
              }
          }

          pauseVideo();

          let timePickerValue = getSpecificTimeOfDay(0, 0, 0);
          if (youtubeRef.current) {
              const currentTime = youtubeRef.current.getCurrentTime();
              const {currentHours, currentMinutes, currentSeconds} =
                  getCurrentHoursMinutesSeconds(currentTime);
              timePickerValue = getSpecificTimeOfDay(
                  Math.floor(currentHours),
                  Math.floor(currentMinutes),
                  Math.floor(currentSeconds),
              );
          } else if (videoOtherContainerRef.current) {
              const lTime = await videoOtherContainerRef.current?.onGetCurrentTime();
              const {currentHours, currentMinutes, currentSeconds} =
                  getCurrentHoursMinutesSeconds(lTime);
              timePickerValue = getSpecificTimeOfDay(
                  Math.floor(currentHours),
                  Math.floor(currentMinutes),
                  Math.floor(currentSeconds),
              );
          }

          form.setFieldValue('content','');
          form.setFieldValue("time", timePickerValue);
          setDrawerVisible(true);

          //重置.
          setHasLoop(false);
          setEndTime(0);
          setCapturePath('');
      };
      const editNote = (note: VideoNoteType) => {
          const {time: timestamp, title, content} = note;
          const dayjsObject = dayjs(timestamp);
          form.setFieldsValue({
              title,
              time: dayjsObject,
              content,
          });
          //重置.
          setHasLoop(note.loop);
          if (note.endTime > 0){
              setEndTime(dayjs(note.endTime));
          }else{
              setEndTime(0);
          }
          setCapturePath(note.thumbImage);

          setDrawerVisible(true);
          setTimeout(() => {
              setEditedNote(note);
          }, 0);
      };
      const deleteNote = async (note: VideoNoteType) => {
          const currentNotes = await getCurrentNotes();
          let newElementVideoNotes = currentNotes.filter((item: { id: string }) => item.id !== note.id);
          mutateElement(element, {videoNotes: newElementVideoNotes}, false);
          setElementVideoNotes(newElementVideoNotes);

          videoCache.set(element.id, newElementVideoNotes);
          updateToDb(newElementVideoNotes);
          if (onAction) {
              onAction('deleteNote', note)
          }

          //刷新注记
          if (window.onRefreshAnnoCount){
              window.onRefreshAnnoCount();
          }
      };
      const importNote = async () => {
          if (!hasLicense() && !hasDesktopBaseLicense() && elementVideoNotes.length == 0) {
              let isBeyond = await beyondFreeYoutubeHightlightLimit();
              if (isBeyond) {
                  window.showMessageBox(i18n.t("Upgrade required"), i18n.t("NeedUpgradeToAddVideoHightlight"), i18n.t("Cancel"), i18n.t("Learn more"), () => {
                      window.closeDialogFileImportLoading();
                  }, () => {
                      window.closeDialogFileImportLoading();
                      if (isZh()) {
                          ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                      } else {
                          ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                      }
                  })
                  return;
              }
          }

          // inputFileRef.current!.click();
          window.showDialogImportHighlight((file, content) => {
              if (file) {
                  importCurrentElementVideoNotes({target: {files: [file]}})
              } else if (content) {
                  importText(content);
              }
          });
      };
      const onPlayerReady: YouTubeProps["onReady"] = (event) => {
          mYoutubeTitle.current = event.target?.videoTitle;
          //取这个card,然后更新标题
          getCardById(element?.customData?.generationData?.id || element.id).then(async (res)=>{
              if (res){
                  if (!res.name){
                      res.name = mYoutubeTitle.current;
                      await updateCard(res);
                      //更新highlight中的标题
                      const highlight = await dbGetHighlight(element.id);
                      if (highlight){
                          highlight.name = res.name;
                          await updateHighlight(highlight);
                      }
                      //刷新标题....
                      postMessage(EVENT_REFRESH_VIDEO_TITLE);
                      window.globalRefreshList('refreshLibrarySingleItem_',res.id);
                  }

              }
          })

          if (!isWeb()){
              //只有web才用这个...
              return;
          }

          youtubeRef.current = event.target;
          setIsLoading(false);
          event.target.pauseVideo();
          const iframe = event.target.getIframe() as HTMLIFrameElement;
          iframe.style.width = "100%";
          iframe.style.height = "100%";
          iframeYoutubeRef.current = iframe;
          iframe.addEventListener('load',async ()=>{
              // console.log(iframe.contentDocument);
          })

          const duration = event.target.getDuration(); //秒

          const remaining = getRemainingHoursMinutesSeconds(duration);

          disabledTime.current = {
              disabledHours: () => remaining.remainingHoursRange,
              disabledMinutes: () => remaining.remainingMinutesRange,
              disabledSeconds: () => remaining.remainingSecondsRange,
          };
          setTimeout(() => {
              setIsReady(true);
          }, 100);

          // intervalRef.current = setInterval(()=>{
          //     //处理是否有循环---或者结果
          //     if (mActiveNoteRef.current?.endTime){
          //         let nCurTime = youtubeRef.current.getCurrentTime();
          //         let nStartTime = getSeconds(mActiveNoteRef.current?.time);
          //         let nEndTime = getSeconds(mActiveNoteRef.current?.endTime);
          //
          //         if (nCurTime > (nEndTime + 1)){
          //             youtubeRef.current?.seekTo(nStartTime);
          //             if (!mActiveNoteRef.current.loop){
          //                 youtubeRef.current.pauseVideo();
          //             }
          //         }
          //     }
          // },200)

          // html2canvas(iframe).then(res=>{
          //     console.log(res);
          // })

          // var canvas = document.createElement('canvas');
          // canvas.width = 640;
          // canvas.height = 480;
          // var ctx = canvas.getContext('2d');
          // var video = iframe.contentDocument.querySelector(".html5-video-container > video");
          // ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          // var dataURI = canvas.toDataURL('image/jpeg');
          // console.log(dataURI);
          if (activeNote) {
              clickOneNote(activeNote)
          }
      };
      const getCurrentElementVideoNotes = () => {
          const exportValues = mElementVideoNotesRef.current.reduce((pre, item) => {
              let endTime = '';
              let loop = '';
              if (item.endTime > 0){
                  endTime = '-'+getTimeText(item.endTime);
              }
              if (item.loop){
                  loop = '[loop]'
              }
              return `${pre}[timestamp]:${getTimeText(item.time)}${endTime}${loop}
${item.title}
${item.content}
`;
          }, "");

          return exportValues;
      };

      const exportCurrentElementVideoNotes = () => {
          let szName = youtubeRef.current?.videoTitle;
          if (libraryDataRef.current) {
              szName = libraryDataRef.current.name;
          }

          const exportValues = {
              videoTitle: szName,
              pastedText: mElementVideoNotesRef.current.reduce((pre, item) => {
                  let endTime = '';
                  let loop = '';
                  if (item.endTime > 0){
                      endTime = '-'+getTimeText(item.endTime);
                  }
                  if (item.loop){
                      loop = '[loop]'
                  }
                  return `${pre}[timestamp]:${getTimeText(item.time)}${endTime}${loop}
${item.title}
${item.content}
`;
              }, ""),
          };
          return exportValues;
      };

      const importCurrentElementVideoNotes = async (
          event: React.ChangeEvent<HTMLInputElement>,
      ) => {

          const files = event.target.files;
          if (!files || files.length === 0) {
              return;
          }

          const file = files[0];

          const reader = new FileReader();
          const slice = file.slice(0, 4096); // 前4KB
          const arrayBuffer = await slice.arrayBuffer();
          const buffer = new Uint8Array(arrayBuffer);
          // 检测编码
          const detected = chardet.detect(buffer);

          reader.onload = (event: ProgressEvent<FileReader>) => {
              const fileContent = event.target?.result as any;
              importText(fileContent);
          };
          reader.readAsText(file,detected);
      };

      /**
       * 导入文本
       * @param content
       */
      const importText = (content: string) => {
          if (!content) {
              message.error(i18n.t("InvalidHighlightFormat"));
              return;
          }
          content = content.trim();

          if (!content.includes('[timestamp]:')){//包含这个的不要截取---兼容别的格式。
              const firstTimestampIndex = content.search(/\d{2}:\d{2}:\d{2}/);
              // 截取从第一个时间戳开始的所有文本
              content = content.substring(firstTimestampIndex);
          }

          let newElementVideoNotes: any = [];
          if ((/^(\d{2}:){2}\d{2}/).test(content)){
              const arrayResults = parseVideoTranscript(content);
              for (let i=0;i<arrayResults.length;i++){
                  const item = arrayResults[i];
                  const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                      item.timestamp
                  );
                  newElementVideoNotes.push({
                      id: `${Date.now()}${i}`,
                      title: item.title,
                      content: item.text,
                      time: getSpecificTimeOfDay(
                          hoursMinutesSeconds.hours,
                          hoursMinutesSeconds.minutes,
                          hoursMinutesSeconds.seconds,
                      ).valueOf(),
                      endTime:0,
                      loop:false
                  })
              }
          }else{
              const data = content.split("\n");
              const groups = groupByTimestamp(data);

              if (!content.includes('[timestamp]:')) {
                  newElementVideoNotes = [];
                  for (let i = 0; i < data.length; i++) {
                      const arrayItem = data[i].trim().split(' ');
                      if (arrayItem.length >= 2) {
                          const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                              '00:' + arrayItem[0],
                          );
                          const szText = data[i].trim().replace(arrayItem[0], '').trim();
                          newElementVideoNotes.push({
                              id: `${Date.now()}${i}`,
                              title: szText,
                              content: '',
                              time: getSpecificTimeOfDay(
                                  hoursMinutesSeconds.hours,
                                  hoursMinutesSeconds.minutes,
                                  hoursMinutesSeconds.seconds,
                              ).valueOf()
                          })
                      }
                  }
              } else {
                  newElementVideoNotes = groups.map((group, index) => {
                      let nEndTime:any = 0;
                      let isLoop = false;
                      let nStartTime:any = 0;

                      if (group[0].includes('-') && group.length >= 2){
                          //重新处理timestamp
                          isLoop = group[0].includes('[loop]');
                          let szNewTime = group[0].replace('[timestamp]:','').replace('[loop]','');
                          let arraySplit = szNewTime.split('-');
                          let startMin = timeString2HoursMinutesSeconds(arraySplit[0]);
                          let endMin = timeString2HoursMinutesSeconds(arraySplit[1]);
                          nStartTime = getSpecificTimeOfDay(startMin.hours,startMin.minutes,startMin.seconds);
                          nEndTime = getSpecificTimeOfDay(endMin.hours,endMin.minutes,endMin.seconds);

                          let szContent = '';
                          if (group.length > 2) {
                              for (let g=2;g<group.length;g++){
                                  szContent += group[g]+'\n';
                              }
                              if (szContent.length > 1){
                                  szContent = szContent.substring(0,szContent.length -1);
                              }
                          }

                          return {
                              id: `${Date.now()}${index}`,
                              title: group[1],
                              content: szContent,//filterGroup.slice(2).join("\n"),
                              time: nStartTime.valueOf(),
                              endTime:nEndTime.valueOf(),
                              loop:isLoop
                          };
                      }else{
                          // const filterGroup =
                          //     index === groups.length - 1 ? group.slice(0, -3) : group.slice(0, -2);
                          // let [timestampString, title] = filterGroup;
                          let timestampString = group[0];
                          timestampString = timestampString?.trim();

                          let szTitle = '';
                          let szContent = '';
                          if (group.length > 1) {
                              szTitle = group[1];
                          }
                          if (group.length > 2) {
                              for (let g=2;g<group.length;g++){
                                  szContent += group[g]+'\n';
                              }
                              if (szContent.length > 1){
                                  szContent = szContent.substring(0,szContent.length -1);
                              }
                          }
                          if (timestampString) {
                              const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                                  timestampString.slice(-8),
                              );
                              return {
                                  id: `${Date.now()}${index}`,
                                  title: szTitle,
                                  content: szContent,//filterGroup.slice(2).join("\n"),
                                  time: getSpecificTimeOfDay(
                                      hoursMinutesSeconds.hours,
                                      hoursMinutesSeconds.minutes,
                                      hoursMinutesSeconds.seconds,
                                  ).valueOf(),
                              };
                          }
                      }

                      return null;
                  });
              }
          }


          newElementVideoNotes = newElementVideoNotes.filter(p=>p != null);

          //加入之前的...
          newElementVideoNotes.push(...elementVideoNotes);
          //按时间排序
          newElementVideoNotes.sort((a, b) => {
              return a.time - b.time;
          })

          if (newElementVideoNotes.some(p => p != null && p?.time)) {
              // setElementVideoNotes(newElementVideoNotes);
              mutateElement(element, {videoNotes: newElementVideoNotes}, false);
              setElementVideoNotes(newElementVideoNotes);

              videoCache.set(element.id, newElementVideoNotes);
              updateToDb(newElementVideoNotes);

              //更新到库
              newElementVideoNotes.forEach(async (item) => {
                  onAction('updateNote', {
                      ...item,
                      src: videoNotes.element?.link,
                      name: videoNotes.element?.customData?.generationData?.name,
                      libraryId: videoNotes.element?.customData?.generationData?.id || videoNotes.element?.id
                  });
              })
              window.closeDialogImportHighlight();

              //刷新注记
              if (window.onRefreshAnnoCount){
                  window.onRefreshAnnoCount();
              }
          } else {
              message.error(i18n.t("InvalidHighlightFormat"));
          }
      }

      /**
       * 搜索
       * @param szSearchKey
       */
      const onSearch = async (szSearchKey: any) => {
          mszSearchKeyRef.current = szSearchKey;
          const currentElementVideoNotes = await getCurrentNotes();
          let arraySearchElements = [];
          if (szSearchKey) {
              for (let i = 0; i < currentElementVideoNotes.length; i++) {
                  const note = currentElementVideoNotes[i];
                  if (note.title && note.title.toLowerCase().indexOf(szSearchKey) != -1) {
                      arraySearchElements.push(note);
                  } else if (note.content && note.content.toLowerCase().indexOf(szSearchKey) != -1) {
                      arraySearchElements.push(note);
                  }
              }
          } else {
              arraySearchElements.push(...currentElementVideoNotes);
          }
          setElementVideoNotes(arraySearchElements);
      }

      // 关闭弹窗，视频要停止播放
      // const pauseVideo = () => {
      //   youtubeRef.current?.pauseVideo();
      // };
      useImperativeHandle(ref, () => ({
          getCurrentElementVideoNotes,
          exportCurrentElementVideoNotes,
          pauseVideo,
          onSearch: onSearch,
          refreshVideoNotes,
          onImportHighlights,
          saveExportElementVideoNotes,
          onGetCapture
      }));

      useEffect(()=>{
          mActiveNoteRef.current = activeNote;
      },[activeNote])

      useEffect(() => {
          if (!drawerVisible) {
              form.setFieldsValue({
                  title: "",
                  time: null,
                  content: "",
              });

              setEditedNote(null);
          } else {
              //光标自动激活在正文区域
              setTimeout(() => {
                  inputRef.current!.focus({
                      cursor: "end",
                  });
              }, 100);
          }
      }, [drawerVisible]);

      useEffect(() => {
          mszSearchKeyRef.current = '';
          // const currentElementVideoNotes = videoCache.get(element.id) || [];
          // // @ts-ignore
          // setElementVideoNotes(currentElementVideoNotes);

          dbGetHighlight(element.customData?.generationData?.id || element.id).then(res => {
              if (res) {
                  if (res.data){
                        res.data.sort(
                          (a, b) => getSeconds(a.time) - getSeconds(b.time),
                        );
                  }
                  setElementVideoNotes(res.data || [])
                  libraryDataRef.current = res;
              }else{
                  if (isWeb()){
                      if (element.videoNotes){
                          element.videoNotes.sort(
                              (a, b) => getSeconds(a.time) - getSeconds(b.time),
                          );
                      }
                      setElementVideoNotes(element.videoNotes || [])//no data
                  }else{
                      setElementVideoNotes([])//no data
                  }
              }
          })

          if (isObject(element.selectedId)){
              if (element.selectedId?.type == 'transcript'){
                  //字幕....
                  mAutoPlay.current = true;
              }
          }else if (element.selectedId) {
              const item = element.videoNotes.find(p => p.id == element.selectedId);
              if (item) {
                  let bNeedReload = true;
                  //如果是同一个url不需要重新加载...
                  const szUrl = videoOtherContainerRef.current?.onGetUrl();
                  if (szUrl == element.link){
                      bNeedReload = false;
                  }
                  clickOneNote(item,bNeedReload);

                  setTimeout(() => {
                      autoScrollToSelected(item);
                  }, 100)
              } else {
                  message.error(i18n.t('CantFindVideoHighlight'))
              }
              mAutoPlay.current = true;
              delete element.selectedId;
          }


          if (videoOtherContainerRef.current) {
              setTimeout(() => {
                  setIsLoading(false);
              }, 600)
          }
      }, [element, visibility]);

      useEffect(() => {
          mszCapturePath.current = capturePath;
      }, [capturePath]);

      useEffect(() => {
          mElementVideoNotesRef.current = elementVideoNotes;
      }, [elementVideoNotes]);

      useEffect(()=>{
          intervalRef.current = setInterval(async ()=>{
              //处理是否有循环---或者结果
              let nCurTime = await videoOtherContainerRef.current?.onGetCurrentTime();
              if (videoOtherContainerRef.current && mActiveNoteRef.current?.endTime){
                  let nStartTime = getSeconds(mActiveNoteRef.current?.time);
                  let nEndTime = getSeconds(mActiveNoteRef.current?.endTime);

                  if (nCurTime > (nEndTime + 0.6)){
                      videoOtherContainerRef.current?.onSetCurrentTime(nStartTime);
                      if (!mActiveNoteRef.current.loop){
                          videoOtherContainerRef.current.onPauseVideo();
                      }
                  }
              }

              const isPlay = await videoOtherContainerRef.current?.onIsPlay();
              if (isPlay){
                  tabHighlightTranscriptRef.current?.onScrollToTime(nCurTime);
                  tabHighlightTranscriptFromDialogRef.current?.onScrollToTime(nCurTime);
              }
          },500)

          return ()=>{
              if (intervalRef.current){
                  clearInterval(intervalRef.current)
              }
          }
      },[])



      const refreshVideoNotes = () => {
          mszSearchKeyRef.current = '';
          getCurrentNotes().then(res => {
              setElementVideoNotes(res);
          })
      }

      /**
       * base64截图
       */
      const onGetCapture = async ()=>{
          let szBase64 = '';
          if (youtubeRef.current){

          }else if (videoOtherContainerRef.current) {
              szBase64 = await videoOtherContainerRef.current.onGetVideoThumb()
          }
          return szBase64;
      }

      /**
       * 导入高亮
       * @param file
       * @param content
       */
      const onImportHighlights = (file, content) => {
          if (file) {
              importCurrentElementVideoNotes({target: {files: [file]}})
          } else if (content) {
              importText(content);
          }
      }

      const saveExportElementVideoNotes = async () => {
          saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes());
      }

      /**
       * 获取截图
       */
      const onGetVideoThumb = async (sandBox)=>{
          try {
              const snapShotUrl = await sandBox?.executeJavaScript(`
      window.getSnapShot();
    `)
              return snapShotUrl
          } catch (error) {
              message.error(error);
          }
      }

      /**
       * 截图
       */
      const captureVideoThumb = async () => {
          let szBase64 = '';
          if (youtubeRef.current) {
              // ipcInvoke('capture-youtube-video',{videoId:youtubeRef.current.videoId,time:'0'});
              const ret = await html2canvas(iframeYoutubeRef.current,{
                  useCORS:true,
                  allowTaint:false
              });
              szBase64 = ret.toDataURL("image/png");

              // const sandBox = await getYoutubeThumbImage(src?.videoId,40);
              // szBase64 = await onGetVideoThumb(sandBox);

              // var canvas = document.createElement('canvas');
              // canvas.width = 640;
              // canvas.height = 480;
              // var ctx = canvas.getContext('2d');
              // var video = iframeYoutubeRef.current.contentDocument.querySelector(".html5-video-container > video");
              // if (ctx){
              //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              //     szBase64 = canvas.toDataURL('image/png');
              // }

          } else if (videoOtherContainerRef.current) {
              szBase64 = await videoOtherContainerRef.current.onGetVideoThumb()
          }
          if (szBase64) {
              if (szBase64 == 'data:,'){
                  message.error(t("PleasePlayBefore"));
                  return;
              }
              const szPath = await ipcInvoke('write-base64-image', {
                  fileName: generateUUID2() + '.png',
                  imgBase64: szBase64,
                  compress:true
              });
              setCapturePath(szPath);
          }
      }


      if (!element) {
          return null;
      }

      /**
       * 截图菜单....
       */
      const getCaptureMenu = () => {
          return [
              getItem(t("Replace"), 'replace', null, undefined, undefined, async () => {
                  // captureVideoThumb();
                  window.showDialogChooseImage(async (szImportMode:any,files:any)=>{
                      if (files?.length > 0){
                          const file = files[0];
                          if (file.path){
                              //复制到本地
                              ipcInvoke('delete-files-file',{fileName:capturePath});
                              const szPath = await ipcInvoke('copy-file',{filePath:file.path});
                              setCapturePath(szPath);
                          }else{
                              navigator.clipboard.read().then(async (clipboardItems) => {
                                  for (const clipboardItem of clipboardItems) {
                                      for (const type of clipboardItem.types) {
                                          if (type.startsWith('image/')) {
                                              const blob = await clipboardItem.getType(type);
                                              const reader = new FileReader();

                                              reader.onload = async function(event) {
                                                  const szBase64 = event.target.result;
                                                  if (szBase64){
                                                      const szFileName = 'screenshot_'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.png';
                                                      // 处理图片
                                                      var item = {
                                                          fileName:szFileName,
                                                          data:szBase64.split(',')[1]
                                                      }
                                                      await ipcInvoke('write-base64-files',JSON.stringify([item]));
                                                      setCapturePath(szFileName);
                                                  }
                                              };

                                              reader.readAsDataURL(blob); // 转换图片为DataURL格式
                                          }
                                      }
                                  }
                              });
                          }
                      }
                  });
              }),
              getItem(t("Copy to clipboard"), 'copyToClipboard', null, undefined, undefined, async () => {
                  copyImageToClipboard(capturePath)
              }),
              getItem(t("Delete"), 'delete', null, undefined, undefined, () => {
                  ipcInvoke('delete-files-file', {fileName: capturePath});
                  setCapturePath('');
              }),
          ]
      }

      /**
       * 是否应该使用webview..
       * @param element
       */
      const hasShowVideoOther = (element)=>{
          if (APP_WEB){
              if (isYoutubeUrl(element.link)){
                  return false;
              }
          }else{
              return isSupportVideoAnnoUrl(element.link);
          }
          return true;
      }


      return (
          <div
              className={from == 'slider' ? "" : "video-content-wrapper"}
              style={{
                  height: from != 'slider' ? (isFullScreen ? 'calc(100% - 32px)' : (dialogSize ? `${dialogSize.height}px` : "60vh")) : (isFullScreen ? (document.body.clientHeight - 66) + 'px' : '100%'),
                  // overflow: 'hidden',
                  display: 'flex',
                  flexDirection: from == 'slider' ? 'column' : 'row'
              }}>
              {/*这里改bilibili的视频比例，小屏幕可以显示进度条》。。*/}
              <div className={from == 'slider' ? "" : "video-content-wrapper-left"}
                   style={{height: (from == 'slider') ? (document.body.clientHeight > 1000?'40vh':`${1000*40/document.body.clientHeight}vh`) : '100%', position: 'relative', flexShrink: '0'}}>
                  <Spin style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)'}}
                        indicator={IconIndicatorBlue} spinning={isLoading}/>
                  {
                      // isYoutubeUrl(element.link) && isWeb() &&
                      isYoutubeUrl(element.link) &&//这个时候只用来取标题
                      (
                          <YouTube
                              ref={youtubeElementRef}
                              className="you-tube-container"
                              videoId={src.videoId}
                              opts={{}}
                              onPlay={(event) => {

                              }}

                              onReady={onPlayerReady}
                              style={{
                                  display: isReady ? (isWeb()?"block":'none') : "none",//只能全部用下面的了。。。。不然很可能别的操作上有问题.
                                  background: 'black',
                                  objectFit: 'contain',
                                  width: '100%',
                                  height: (from == 'slider') ? '100%' : '100%',
                                  pointerEvents: pointerEvents || 'all'
                              }}
                          />
                      )}

                  {
                      // isBilibiliUrl(element.link) &&
                      hasShowVideoOther(element) &&
                      <VideoOtherContent ref={videoOtherContainerRef} url={element.link} isAutoPlay={mAutoPlay.current} element={element} pointerEvents={pointerEvents} iframeLoad={()=>{
                          if (mAutoPlay.current){
                              setTimeout(()=>{
                                  videoOtherContainerRef.current?.onPlay();
                              },100)
                          }
                      }}/>
                  }

                  {
                      subFrom == FROM_HOME_DIALOG &&
                      <div style={{
                          width: '100%',
                          minHeight: `${!hasTranscript ? (hasTranscriptBanner?40:0) : (isExpand ? (dialogSize.height - 86) * 0.5 : 40)}px`,
                          height: `${!hasTranscript ? (hasTranscriptBanner?40:0) : (isExpand ? (dialogSize.height - 86) * 0.5 : 40)}px`,
                          position: 'relative',
                          paddingRight: hasTranscript?'6px':'0px',
                      }}>
                          <TabHighlightTranscript ref={tabHighlightTranscriptFromDialogRef}
                                                  elementVideoNotes={elementVideoNotes} from={from}
                                                  subFrom={subFrom}
                                                  type={'dialogOnlyTranscript'}
                                                  activeNote={activeNote} clickOneNote={clickOneNote}
                                                  editNote={editNote} captureVideo={captureVideoThumb}
                                                  confirmNote={confirmNote} addNote={addNote}
                                                  videoNotes={videoNotes} element={element}
                                                  onExportCopyHighlight={async ()=>{
                                                      const text = getCurrentElementVideoNotes();
                                                      await navigator.clipboard.writeText(text);
                                                      message.info(t('Has copyed'))
                                                  }}
                                                  onExportHighlightFile={saveExportElementVideoNotes}
                                                  onHasTranscript={(e) => {
                                                      setHasTranscript(e);
                                                  }}
                                                  onExpand={(e) => {
                                                      setIsExpand(e);
                                                  }}
                                                  deleteNote={deleteNote} onClickTranscript={(item,isAutoPlay) => {
                              mAutoPlay.current = true;
                                                      setTimeout(async ()=>{
                                                          //转到这个时间...
                                                          videoOtherContainerRef.current?.onSetCurrentTime(item.start);
                                                          if (isAutoPlay) {
                                                              await sleep(1600);
                                                              videoOtherContainerRef.current?.onPlay();
                                                          }
                                                      },200)
                          }} onQuickNote={async (item) => {
                              await captureVideoThumb();
                              setTimeout(() => {
                                  confirmNote(true, item.start);
                                  message.destroy();
                                  message.info(t("Highlight saved"))
                              }, 100)
                          }} onSearch={(szSearchKey: any, activeTab: any) => {
                              //搜索
                              if (activeTab == 'highlights') {
                                  onSearch(szSearchKey);
                              } else {

                              }
                          }}/>

                          {
                              isExpand && hasTranscript &&
                              <div className={'transcript-line-line'} style={{
                                  position: 'absolute',
                                  right: '0px',
                                  top: '0px',
                                  height: 'calc(100% + 16px)',
                                  width: '1px',
                                  background: 'var(--line-color-f6)'
                              }}></div>
                          }

                      </div>
                  }

              </div>
              <div className={from == 'slider' ? "" : "video-content-wrapper-right"} style={rightStyle}>
                  <Modal
                      title={<span style={{color: 'var(--text-color)'}}>{i18n.t('Video notes')}</span>}
                      centered
                      zIndex={MEDIIUM_Z_INDEX}
                      open={drawerVisible}
                      mask={false}
                      closable={true}
                      closeIcon={<IconClose20/>}
                      width={(from == 'slider') ? '380px' : "24.8vw"}
                      style={modalStyle}
                      maskClosable={false}
                      styles={{
                          wrapper: {
                              pointerEvents: 'none',
                          },
                      }}
                      bodyStyle={{marginBottom: '0px'}}
                      // footer={null}
                      footer={<div className={'flex-center'} style={{position: 'relative'}}>
                          {
                              !capturePath && !isAudio(element.customData?.generationData.fileName) && HAS_VIDEO_CAPTURE_TEST && !APP_WEB &&
                              <div className={'div-item-container'}
                                   style={{position: 'absolute', left: '0', bottom: '2px'}} onClick={async () => {
                                  //截图
                                  captureVideoThumb();
                              }}>
                                  <img className={'img-16'} src={getImagePathWithTheme('video_capture')}/>
                              </div>
                          }
                          {
                              capturePath &&
                              <div style={{
                                  position: 'absolute',
                                  left: '0px',
                                  top: '6px',
                                  width: '78px',
                                  height: '44px',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                  cursor: 'pointer'
                              }} onMouseEnter={() => {
                                  setIsMouseEnterCapture(true);
                              }} onMouseLeave={() => {
                                  setIsMouseEnterCapture(false);
                              }}>
                                  <img style={{
                                      width: '78px',
                                      height: '44px',
                                      objectFit: 'cover'
                                  }} src={getLocalFilePath(capturePath, false)}/>

                                  {
                                      isMouseEnterCapture &&
                                      <>
                                          <div style={{
                                              background: '#00000033',
                                              height: '100%',
                                              width: '100%',
                                              position: 'absolute',
                                              left: '0',
                                              top: '0',
                                          }} onClick={() => {
                                              window.showImagePreviewWithFullUrl(getLocalFilePath(capturePath, false));
                                          }}></div>

                                          <Dropdown trigger={['click']} menu={{items: getCaptureMenu()}}>
                                              <img className={'img-16 cursor-pointer'}
                                                   style={{position: 'absolute', top: '6px', right: '6px'}}
                                                   src={getImagePathWithTheme('video_capture_more')}/>
                                          </Dropdown>
                                      </>

                                  }
                              </div>
                          }

                          <div onClick={() => {
                              confirmNote();
                          }} className={'button-solid-style flex-center mt-12'}
                               style={{minWidth: '100px'}}>{i18n.t("Confirm")}</div>
                      </div>}
                      onCancel={() => {
                          // confirmNote();
                          setDrawerVisible(false)
                      }}
                  >
                      <Form name="basic" form={form} autoComplete="off" size="small">
                          <div className={'flex-row-vertical-center'}>
                              <Form.Item
                                  label=""
                                  name="title"
                                  style={{display: "inline-block", flexGrow: '1'}}
                              >
                                  <Input ref={inputRef} className={'input-border'} onMouseDown={(event)=>{
                                      event.stopPropagation();
                                  }}  readOnly={APP_WEB} style={{padding: "0 12px"}}/>
                              </Form.Item>
                              <Form.Item
                                  label=""
                                  name="time"
                                  style={{display: "inline-block", paddingRight: '0px'}}
                              >
                                  <TimePicker
                                      variant={'borderless'}
                                      className={'input-border'}
                                      disabled={APP_WEB}
                                      style={{
                                          height: '32px',
                                          marginLeft: '12px',
                                          background: 'transparent',
                                          color: 'var(--text-color)'
                                      }}
                                      showNow={false}
                                      suffixIcon={<img className={'img-16'} src={imgPathPerfix() + 'time_icon.png'}/>}
                                      // disabledTime={() => disabledTime.current}
                                      onChange={onChangeTimePicker}
                                  />
                              </Form.Item>

                              {
                                  HAS_VIDEO_CAPTURE_TEST && !APP_WEB &&
                                  <Form.Item
                                      label=""
                                      name="more"
                                      style={{display: "inline-block", paddingLeft: '12px',}}>
                                      <Popover arrow={false} open={isPopoverEndTimeOpen}
                                               onOpenChange={(e) => setIsPopoverEndTimeOpen(e)} zIndex={MAX_Z_INDEX}
                                               overlayInnerStyle={{padding: '0', margin: '0'}} trigger={['click']}
                                               placement={"bottom"} content={<div
                                          style={{width: '180px', minHeight: '156px', padding: '6px 16px 16px 16px'}}>
                                          <div className={'flex-row-vertical-center video-more-item'}>
                                              <span>{t("End time")}</span>
                                              <Switch style={{width: '32px', marginLeft: 'auto'}} value={endTime > 0}
                                                      onChange={async (e) => {
                                                          if (!e) {
                                                              setEndTime(0);
                                                              setHasLoop(false);
                                                          } else {
                                                              let duration = await getCurrentTime() + 3;
                                                              const nTotalDuration = await getDuration();
                                                              if (duration > nTotalDuration) {
                                                                  duration = nTotalDuration;
                                                              }
                                                              const {currentHours, currentMinutes, currentSeconds} =
                                                                  getCurrentHoursMinutesSeconds(duration);
                                                              const timePickerValue = getSpecificTimeOfDay(
                                                                  Math.floor(currentHours),
                                                                  Math.floor(currentMinutes),
                                                                  Math.floor(currentSeconds),
                                                              );
                                                              setEndTime(timePickerValue);
                                                          }
                                                      }}/>
                                          </div>
                                          {
                                              endTime > 0 &&
                                              <TimePicker
                                                  variant={'borderless'}
                                                  className={'input-border'}
                                                  style={{
                                                      height: '32px',
                                                      background: 'transparent',
                                                      color: 'var(--text-color)',
                                                      width: '100%',
                                                  }}
                                                  value={(endTime)}
                                                  showNow={false}
                                                  suffixIcon={<img className={'img-16'}
                                                                   src={imgPathPerfix() + 'time_icon.png'}/>}
                                                  // disabledTime={() => disabledTime.current}
                                                  onChange={(e) => {
                                                      setEndTime(e);
                                                  }}
                                              />
                                          }
                                          <div className={'flex-row-vertical-center video-more-item'}>
                                              <span>{t("Loop")}</span>
                                              <Switch value={hasLoop} style={{width: '32px', marginLeft: 'auto'}}
                                                      onChange={(e) => {
                                                          if (endTime && endTime.year() > 1970) {
                                                              setHasLoop(e);
                                                          } else {
                                                              message.error(t("PleaseSetAnEndTime"));
                                                              setHasLoop(false);
                                                          }
                                                      }}/>
                                          </div>
                                          <div className={'flex-center mt-8'}>
                                              <Button
                                                  className='button-solid-style font-size-14 font-family-medium border-radius-8'
                                                  type="primary"
                                                  style={{minWidth: '90px', height: '32px'}}
                                                  onClick={() => {
                                                      setIsPopoverEndTimeOpen(false);
                                                  }}>{t("Ok")}</Button>
                                          </div>

                                      </div>}>
                                          <div className={'video-v-more flex-center cursor-pointer'}>
                                              <img className={'img-16'} src={getImagePathWithTheme('anno_video_v_more')}/>
                                          </div>
                                      </Popover>
                                  </Form.Item>
                              }

                          </div>
                          <Form.Item label="" name="content">
                              <Input.TextArea
                                  readOnly={APP_WEB}
                                  autoSize={{minRows: 8, maxRows: 8}}
                                  style={{whiteSpace: "initial", padding: '12px', background: 'transparent'}}
                                  placeholder="Add note..."
                              />
                          </Form.Item>
                      </Form>
                  </Modal>

                  <TabHighlightTranscript ref={tabHighlightTranscriptRef} elementVideoNotes={elementVideoNotes} from={from} subFrom={subFrom}
                                          activeNote={activeNote} clickOneNote={clickOneNote}
                                          editNote={editNote} captureVideo={captureVideoThumb}
                                          confirmNote={confirmNote} addNote={addNote}
                                          videoNotes={videoNotes} element={element}
                                          onExportCopyHighlight={async ()=>{
                                              const text = getCurrentElementVideoNotes();
                                              await navigator.clipboard.writeText(text);
                                              message.info(t('Has copyed'))
                                          }}
                                          onExportHighlightFile={saveExportElementVideoNotes}
                                          deleteNote={deleteNote} onClickTranscript={(item)=>{
                      //转到这个时间...
                      videoOtherContainerRef.current!.onSetCurrentTime(item.start);
                  }} onQuickNote={async (item)=>{
                      await captureVideoThumb();
                      setTimeout(() => {
                          confirmNote(true,item.start);
                          message.destroy();
                          message.info(t("Highlight saved"))
                      }, 100)
                  }} onSearch={(szSearchKey:any,activeTab:any)=>{
                      //搜索
                      if (activeTab == 'highlights') {
                          onSearch(szSearchKey);
                      }else{

                      }
                  }}/>

                  {/*拼一根横线，里面没法拼，有间距，所有布局要全部调整*/}
                  {
                      subFrom == FROM_HOME_DIALOG &&
                      <div className={'line-f6'}
                           style={{position: 'absolute', bottom: '62px', width: '100%', marginLeft: '-20px'}}></div>
                  }

              </div>
          </div>
      );
  }),
);

export default VideoContent;
